import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1988ce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-center flex-column mt-2 mb-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-black text-weight-600 text-center" }, [
  /*#__PURE__*/_createTextVNode("\n        お仕事の準備が完了しました"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        勤務当日のご活躍を応援しています！\n      ")
], -1))
const _hoisted_4 = { class: "mt-2 mx-3 mb-4" }

import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { inAppReviewService } from "@/app/services/InAppReviewService";
import { orderService } from "@/app/services/OrderService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import RecentOrders from "@/components/molecules/orders/RecentOrders.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { orderStore } from "@/store/order";
import { Order } from "@/types/order/Order";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReserveCompleted',
  setup(__props) {

const errorModal = useErrorModal();
const loader = useLoader();
const router = useRouter();

const orders = ref<Order[]>([]);
const applicableOrderCount = ref(0);

onMounted(async () => {
  await inAppReviewService.launchInAppReview("APPLY_ORDER");
});

onBeforeMount(async () => {
  try {
    loader.show();
    await fetchEachDayOrders();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const mascotImage = computed(() =>
  require("@/assets/svg/caikuma_send_message" +
    authStore.productAssetSuffix +
    ".svg")
);
const selectedOrder = computed(() => orderStore.orderDetail);

function onClickBack() {
  router.go(-6);
}
async function fetchEachDayOrders() {
  const { results, count } = await orderService.fetchOrdersEachDayWithCount({
    office: selectedOrder.value!.office.id,
    serviceName: authStore.workerService.serviceName,
    onlyHiring: true
  });
  orders.value = results;
  applicableOrderCount.value = count;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n    申し込み完了\n  ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          width: "114",
          src: mascotImage.value
        }, null, 8, _hoisted_2),
        _createTextVNode(),
        _hoisted_3
      ]),
      _createTextVNode(),
      _createVNode(RecentOrders, {
        title: "この事業所様の他のお仕事",
        titleClass: "recent-orders-title",
        class: "px-3 py-3",
        currentOrder: selectedOrder.value,
        orders: orders.value,
        applicableOrderCount: applicableOrderCount.value
      }, null, 8, ["currentOrder", "orders", "applicableOrderCount"]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AppButton, {
          class: "w-100 mt-2",
          to: { name: 'Search' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("引き続き他の仕事を探す")
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    _createTextVNode(),
    _createVNode(AppFooter),
    _createTextVNode(),
    _createVNode(BlockBack)
  ], 64))
}
}

})